<template>
    <el-dialog title="Date cu caracter personal" :visible.sync="showPopup" width="60%" >
        <div>
            <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" ref='my-form' :model='selectedObject' @submit.prevent="save" >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label='Devize' prop="id">
                            <el-select clearable style="width:100%" v-model="selectedObject.id" multiple placeholder="Select">
                                <el-option v-for="item in devizeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="15">
                    <el-col :md="12">
                        <el-form-item prop="nume" class="form-lj" label="Nume">
                            <el-input v-model="selectedObject.nume"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12">
                        <el-form-item prop="prenume" class="form-lj" label="Prenume">
                            <el-input v-model="selectedObject.prenume"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12">
                        <el-form-item prop="telefon" class="form-lj" label="Telefon">
                            <el-input v-model="selectedObject.telefon"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12">
                        <el-form-item prop="email" class="form-lj" label="Email">
                            <el-input v-model="selectedObject.email"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="12">
                        <el-form-item prop="tip" label="Tip persoana">
                            <el-select style="width:100%" v-model="selectedObject.tip" placeholder="Tip persoana">
                                <el-option label="Fizica" value="fizica"></el-option>
                                <el-option label="Juridica" value="juridica"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <hr>
                <el-row v-if="selectedObject.tip == ''"><p class="tip-persoana">Te rog alege tipul de persoana intai</p></el-row>
                <el-row v-else-if="selectedObject.tip === 'fizica'" :gutter="15">
                    <el-col :md="24">
                    <el-form-item prop="adresa" id="adresa" label="Adresa">
                        <el-input v-model="selectedObject.adresa"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :md="12">
                        <el-form-item prop="judet" label="Judet">
                        <el-select style="width:100%" size="large" filterable v-model="selectedObject.judet" @change="filtru_judet(selectedObject.judet)" placeholder="Alege un judet">
                        <el-option v-for="judet in Info.judete" :key="judet.Id + '_' + judet.Nume" :label="judet.Nume" :value="judet.IdEvio"></el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                    <el-col :md="12">
                    <el-form-item v-if="status_localitate" prop="localitate" class="form-lj" label="Localitate">
                        <el-select style="width:100%" size="large" filterable v-model="selectedObject.localitate" placeholder="Alege o localitate">
                        <el-option v-for="localitate in Info.localitati" :key="localitate.Id + '_' + localitate.Nume" :label="localitate.Nume" :value="localitate.IdEvio"></el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-else-if="selectedObject.tip === 'juridica'">
                    <el-form-item  prop="cui" label="CUI">
                    <div style="display:flex;align-items:center;gap:12px;">
                        <el-input size="mini" v-model="selectedObject.cui"/>
                        <el-button @click="verificareAnaf" size="mini">Verificare ANAF</el-button>
                    </div>
                    </el-form-item>
                </el-row>
                <el-row v-if="denumireFirma != ''">
                    <el-col :span="24">
                    <div>Denumire firma: {{ denumireFirma }}</div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer" >                      
            <el-button @click="closeDialog" > Renunta  </el-button>                
            <el-button type="success" @click="factureaza()" > Trimite </el-button>
        </span>
    </el-dialog>
</template>

  <script>
  import BasePage from "@/pages/Admin/BasePage";
  export default {
    name: "Devize_factura_multipla_dialog",
    extends: BasePage,
    data() {
      return {
        showPopup: false,
        selectedObject:{id:[],nume:'',idClient:'',telefon:'',email:'',prenume:'',tip:'',adresa:'',cui:'',judet:null,localitate:null},
        devizeOptions:[],
        denumireFirma:"",
        Info:{
            localitati:[],
            judete:[],
        },
        status_localitate:false,
        rules: {
            id: [{ required: true, message: 'Campul este obligatoriu'}],
            nume: [{ required: true, message: 'Campul este obligatoriu'}],
            prenume: [{ required: true, message: 'Campul este obligatoriu'}],
            telefon: [{ required: true, message: 'Campul este obligatoriu'}],
            email: [{ required: true, message: 'Campul este obligatoriu'}],
            tip: [{ required: true, message: 'Campul este obligatoriu'}],
            adresa: [{ required: true, message: 'Campul este obligatoriu'}],
            cui: [{ required: true, message: 'Campul este obligatoriu'}],
            judet: [{ required: true, message: 'Campul este obligatoriu'}],
            localitate: [{ required: true, message: 'Campul este obligatoriu'}],
            cui: [{ required: true, message: 'Campul este obligatoriu'}],
        },
      };
    },
    methods: {
        async show_me(idClient,numeClient,prenumeClient,telefonClient,emailClient,judete){
            try {
                this.selectedObject = {id:[],idClient:'',telefon:'',email:'',prenume:'',tip:'',adresa:'',cui:'',judet:null,localitate:null};
                this.status_localitate = false;
                this.denumireFirma = "";

                this.Info.judete = [...judete];

                this.selectedObject.nume = numeClient;
                this.selectedObject.prenume = prenumeClient;
                this.selectedObject.telefon = telefonClient;
                this.selectedObject.email = emailClient;

                this.selectedObject.idClient = idClient ? idClient : null;
                const response = await this.post("receptie/devize/get_devize_pe_client", { idClient: idClient });
                if(response && response.devize){
                    this.devizeOptions = response.devize;
                }else{
                    this.devizeOptions = {};
                }
            } catch (error) {
                console.error(error)
            }
            this.showPopup = true;
        },
        async filtru_judet(id) {
            let response = await this.post("receptie/devize/get_localitati_filtrate", {
                IdJudet: id,
            });
            this.Info.localitati = response.localitati;
            this.status_localitate = true;
        },
        closeDialog(){
            this.showPopup = false
        },

        async factureaza() {
      
            this.$refs['my-form'].validate(async (valid) => {
                if (valid) {
                    if (this.selectedObject.tip === 'juridica') {
                        this.selectedObject.adresa = 'notset';
                        this.selectedObject.localitate = 'notset';
                        this.selectedObject.judet = "notset";
                    }

                    const raspuns = await this.post("receptie/devize/factureaza_deviz", {IdDeviz:this.selectedObject.id, DateSuplimentare: this.selectedObject}, {
                        headers: {'Access-Control-Allow-Origin': '*'}
                    });
                    if (Number(raspuns.success) == 1) {
                    this.$message({
                        message: 'Factura a fost trimisa cu success',
                        type: 'success'
                    });
                    } else if (Number(raspuns.success) == 0) {

                    if(typeof raspuns.EroareEvio.Mesaj != undefined ){
                        this.$message({
                        message: raspuns.EroareEvio.Mesaj,
                        type: 'error'
                        });
                    } else {
                        this.$message({
                        message: 'A aparut o eroare la facturare.',
                        type: 'error'
                        });
                    }
                    } else {
                    this.$message({
                        message: 'A aparut o eroare la facturare.',
                        type: 'error'
                    });
                }
            }

            this.showPopup = false;
        });
     },  
        async verificareAnaf(){
            let cui = this.selectedObject.cui;
            if (cui.startsWith('RO')) {
                cui = this.selectedObject.cui.substring(2).trim();
            } else {
                cui = this.selectedObject.cui.trim();
            }

            const response = await this.post('receptie/devize/verificare_anaf', {cui:cui});
            if (response.Results.error) {
            this.$message({ message: 'CUI invalid', type: 'error',duration:4500 });
            }else{
            if(!response.Results.info || response.Results.info.denumire === ''){
                this.$message({ message: 'CUI invalid', type: 'error',duration:4500 });
            }else{
                this.denumireFirma = response.Results.info.denumire;
            }
        }
    },
        
    },
    mounted: function () {},
  };
  </script>
  
  <style lang="less" scoped>
  
  .tip-persoana {
    text-align: center;
    opacity: 0.5;
    
  }
  </style>